import React from 'react';

const TenantRow = ({ tenant, selected, onSelect }) => {
  // Calculate taxAmount as 0.16 * amount / 1.16
  const taxAmount = tenant.amount ? (0.16 * tenant.amount / 1.16) : 0;

  // Determine status color and label
  let statusClass = '';
  let statusLabel = '';
  switch (tenant.invoice_status) {
    case 'paid':
      statusClass = 'bg-green-100 text-green-700';
      statusLabel = 'Paid';
      break;
    case 'partial':
      statusClass = 'bg-yellow-100 text-yellow-700';
      statusLabel = 'Partial';
      break;
    case 'unpaid':
    default:
      statusClass = 'bg-red-100 text-red-700';
      statusLabel = 'Unpaid';
      break;
  }

  return (
    <tr className="hover:bg-gray-50 transition">
      <td className="px-4 py-3">
        <input
          type="checkbox"
          className="border-gray-300 rounded focus:ring-blue-500 text-blue-600 form-checkbox"
          checked={selected}
          onChange={() => onSelect(tenant.tenant_id)}
        />
      </td>
      <td className="px-4 py-3">
        <div className='flex flex-col'>
          <span className='font-medium'>{tenant.user_name}</span>
          <span className='text-gray-400'>{tenant.user_phone_number}</span>
        </div>
      </td>
      <td className="px-4 py-3">
        <div className='flex flex-col'>
          <span className='font-medium'>{tenant.house_number}</span>
          <span className='text-gray-400'>{tenant.apartment_name}</span>
        </div>
      </td>
      <td className="px-4 py-3">{tenant.kra_pin}</td>
          <td className="px-4 py-3">
        <div className='flex flex-col'>
          <span className='font-medium capitalize'>{tenant.invoice_month},{tenant.invoice_year}</span>
        </div>
      </td>
      <td className="px-4 py-3">
        KES {(parseFloat(tenant?.amount ?? 0) - parseFloat(taxAmount ?? 0))
          .toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
      </td>

      <td className="px-4 py-3">
        KES {parseFloat(taxAmount ?? 0)
          .toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
      </td>

      {/* <td className="px-4 py-3">KES {tenant?.totalAmount?.toLocaleString()}</td> */}
      <td className="px-4 py-3">KES {parseInt(tenant?.amount?.toString()).toLocaleString()}</td>

      <td className="px-4 py-3">
        <span className={`inline-block px-2 py-1 rounded text-xs font-medium ${statusClass}`}>
          {statusLabel}
        </span>
      </td>
    </tr>
  );
};

export default TenantRow;